export default __webpack_public_path__ + "static/media/1689.cb39d97b.png";